import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import {
    fetchProductLocalisationFailure,
    fetchProductLocalisationSuccess,
} from 'store/actions/product-localisation/fetchProductLocalisation';
import {
    updateProductLocalisationFailure,
    updateProductLocalisationSuccess,
} from 'store/actions/product-localisation/updateProductLocalisation';
import { put, takeLatest } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

const DEFAULT_PAGE_SIZE = 48;

function* fetchProductLocalisationAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        ...query
    } = payload;

    query.size = query.size || DEFAULT_PAGE_SIZE;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/products/${ id }/localisation`;

        // Fetch the data.
        const response = yield apiClient.read(url, query);

        // Send the data the success action.
        yield put(fetchProductLocalisationSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(fetchProductLocalisationFailure(error, payload));

        yield onError(error);
    }
}

function* updateProductLocalisationAsync({ payload }) {
    const {
        id,
        formValues,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ id }/localisation`;

        const response = yield apiClient.update(url, formValues.localisation);

        yield put(updateProductLocalisationSuccess(payload, response));

        yield onSuccess();
    } catch (error) {
        yield put(updateProductLocalisationFailure(error));

        yield onError(error);
    }
}

function* updateProductLocalisationSuccessAsync() {
    yield put(showNotification('notifications.products.localisation.update.success'));
}

function* failureMessage({ error }) {
    const {
        message,
    } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* productLocalisationSagas() {
    yield [
        takeLatest('FETCH_PRODUCT_LOCALISATION', fetchProductLocalisationAsync),
        takeLatest('FETCH_PRODUCT_LOCALISATION_FAILURE', failureMessage),
        takeLatest('UPDATE_PRODUCT_LOCALISATION', updateProductLocalisationAsync),
        takeLatest('UPDATE_PRODUCT_LOCALISATION_FAILURE', failureMessage),
        takeLatest('UPDATE_PRODUCT_LOCALISATION_SUCCESS', updateProductLocalisationSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productLocalisationSagas.js